import React, { Children, FC, ReactElement, ReactNode } from 'react';

import { SCP } from 'ia-react-core/~/interfaces/SCP';
import SideNavAnchor from '../SideNavAnchor';
import SideNavLink, { SideNavLinkProps } from '../SideNavLink';

import BackLink from '../BackLink';
import {
  StyledList,
  StyledListItem,
  StyledNav,
} from './SideNav.styles';
import Spacing from '../../grid/Spacing';

const PUBLIC_PROPS = ['children', 'bottomBorder', 'backPage', 'backPageLabel'] as const;

export interface SideNavProps extends SCP<'nav'> {
  children?: ReactNode;
  /** Bottom border style. */
  bottomBorder?: string;
  /** Link for the optional back button. */
  backPage?: string;
  /** Label for the optional back button. */
  backPageLabel?: string;
}

export interface SideNavStatics {
  StyledNav: typeof StyledNav;
  Link: typeof SideNavLink;
  Anchor: typeof SideNavAnchor;
  type: Symbol;
  publicProps: typeof PUBLIC_PROPS;
}

const SideNav: FC<SideNavProps> & SideNavStatics = ({ children, bottomBorder, backPage, backPageLabel, ...props }) => {
  const links = Children.toArray(children) as ReactElement<SideNavLinkProps>[];

  return (
    <StyledNav
      {...props}
    >
      {backPage ? (
        <Spacing m-b={20}>
          <BackLink largerArrow to={backPage}>{backPageLabel}</BackLink>
        </Spacing>
      ) : null}
      <StyledList bottomBorder={bottomBorder}>
        {links.map((link, index) => (
          <StyledListItem key={link.props.id || link.props.to as string || index}>
            {link}
          </StyledListItem>
        ))}
      </StyledList>
    </StyledNav>
  );
};

SideNav.StyledNav = StyledNav;
SideNav.Link = SideNavLink;
SideNav.Anchor = SideNavAnchor;
SideNav.type = Symbol('SideNav');
SideNav.publicProps = PUBLIC_PROPS;

export default SideNav;
